import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slider.css";
import { ChevronRight, ChevronLeft
 } from "lucide-react";
import { Link } from "react-router-dom";

const OurPresence = ({ OurPresenceData }) => {
    console.log("data got from here : ",OurPresence)
    const [itemIndex, setItemIndex] = useState(0);

    const NextArrowTwo = ({ onClick }) => (
        <div
            className="bg-black bg-opacity-70 absolute cursor-pointer z-10 right-0 top-1/2 transform -translate-y-1/2 p-2 rounded-full hover:bg-opacity-90 transition-colors duration-300"
            onClick={onClick}
        >
            <ChevronRight size={24} color="white" />
        </div>
    );

    const PrevArrowTwo = ({ onClick }) => (
        <div
            className="bg-black bg-opacity-70 absolute cursor-pointer z-10 left-0 top-1/2 transform -translate-y-1/2 p-2 rounded-full hover:bg-opacity-90 transition-colors duration-300"
            onClick={onClick}
        >
            <ChevronLeft size={24} color="white" />
        </div>
    );

    const settingsTwo = {
        infinite: true,
        lazyLoad: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
        centerMode: true,
        centerPadding: "0",
        nextArrow: <NextArrowTwo />,
        prevArrow: <PrevArrowTwo />,
        beforeChange: (current, next) => setItemIndex(next),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    };

    return (
        <div>
            <div
                className="our-presence-slider bg-cover bg-center md:py-14 flex flex-col justify-center 
                items-center text-center text-white relative "
            >
                <div className="Desktop rounded-md container mx-auto no-underline px-4">
                    <Slider {...settingsTwo} className="flex">
                        {OurPresenceData.location.map((item, idx) => (
                           <Link
                           to={item.url}
                           alt={item.alt}
                           target="_blank"
                           key={idx}
                           className={`rounded-xl transition-opacity duration-300 ease-in-out no-underline ${
                               idx === itemIndex ? "opacity-100" : "opacity-75"
                           }`}
                       ><div
                       className="no-underline w-full h-[380px] md:h-[280px] rounded-xl text-center
                        bg-white border-2 border-gold
                       transition-colors duration-300 ease-in-out 
                       flex flex-col justify-between bg-cover bg-center overflow-hidden"
                       style={{ backgroundImage: `url(${item.image})` }}
                   >
                       <div className="bg-black bg-opacity-10 w-full h-full
                           flex items-end justify-center rounded-xl no-underline">
                           <h3 className="text-white text-[18px] mb-4 no-underline font-semibold">{item.name}</h3>
                          
                       </div>
                   </div>
                   
                       </Link>         
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default OurPresence;
